export const promotionBanner = 'promotion_banner'

export const simplifiedCardTitle = 'simplified_card_title'

export const inviteTravelCrew = 'invite_travel_crew'

export const googleAuthentication = 'google_authentication'

export const staysAdventuresDropdown = 'stays_adventures_dropdown'

export const petFees = 'pet_fees'

export const hostPetFees = 'host_pet_fees'
